// extracted by mini-css-extract-plugin
export var card = "_t2-0";